import { BASE_API } from "../common/constants/constants";
import { getLocal } from "../helpers/Local";
import Axios from "axios";

const authToken = () => getLocal("cvai-auth-token");

// Get integration settings
export const getIntegrationSettings = (integrationType) => {
  return Axios.get(`${BASE_API}integrations/${integrationType}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authToken(),
    },
  });
};

// Save integration settings (using POST to match the API route)
export const saveIntegrationSettings = (integrationType, data) => {
  return Axios.post(`${BASE_API}integrations/${integrationType}`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authToken(),
    },
  });
};

// Delete integration settings
export const deleteIntegrationSettings = (integrationType) => {
  return Axios.delete(`${BASE_API}integrations/${integrationType}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authToken(),
    },
  });
};

// Test integration connection
export const testIntegrationConnection = (integrationType) => {
  return Axios.post(
    `${BASE_API}integrations/${integrationType}/test`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken(),
      },
    }
  );
};
